import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`To capture network requests in your recordings, add `}<inlineCode parentName="p">{`PostHogOkHttpInterceptor`}</inlineCode>{` to your `}<inlineCode parentName="p">{`OkHttp Interceptor`}</inlineCode>{`. `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-android_kotlin"
      }}>{`import com.posthog.PostHogOkHttpInterceptor
import okhttp3.OkHttpClient

private val client = OkHttpClient.Builder()
    .addInterceptor(PostHogOkHttpInterceptor(captureNetworkTelemetry = true))
    .build()
`}</code></pre>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` Only metric-like data like speed, size, and response code are captured. No data is captured from the request or response body.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      